
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/l1-holders",
      function () {
        return require("private-next-pages/l1-holders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/l1-holders"])
      });
    }
  